var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlane = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10.5H14.4284L11.144 4.75188C11.1002 4.67535 11.037 4.61175 10.9607 4.56752C10.8844 4.52329 10.7978 4.49999 10.7096 4.5L8.66276 4.5C8.33057 4.5 8.09088 4.81781 8.18213 5.13719L9.71432 10.5H6.49993L5.14993 8.7C5.05555 8.57406 4.90711 8.5 4.74993 8.5H3.50023C3.17492 8.5 2.93617 8.80562 3.01523 9.12125L3.99992 12.5L3.01523 15.8787C2.93617 16.1944 3.17492 16.5 3.50023 16.5H4.74993C4.90743 16.5 5.05555 16.4259 5.14993 16.3L6.49993 14.5H9.71432L8.18213 19.8625C8.09088 20.1819 8.33057 20.5 8.66276 20.5H10.7096C10.889 20.5 11.0546 20.4038 11.1437 20.2481L14.4284 14.5H18C19.1047 14.5 21 13.6047 21 12.5C21 11.3953 19.1047 10.5 18 10.5Z",
    fill: "#212121"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlane);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/plane.518b1cb716733dcde627e89416b6858c.svg";